export const iconFontAwesomeMapsMusic = (
	<i className="fa-solid fa-music"></i>
);
